<template>
    <div class="dashboard-page">
        <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
            <div class="breadcrumb-title pe-3">Dashboard</div>
            <div class="ps-3">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb mb-0 p-0">
                        <li class="breadcrumb-item">
                            <a href="javascript:void(0);"><i class="bx bx-home-alt"></i></a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Overview</li>
                    </ol>
                </nav>
            </div>
        </div>

        <div class="row g-3 mb-3">
            <div class="col-12 col-sm-6 col-xl-3" v-for="card in summaryCards" :key="card.key">
                <div class="card dashboard-stat-card h-100">
                    <div class="card-body">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <p class="stat-label mb-1">{{ card.label }}</p>
                                <h4 class="stat-value mb-0">{{ data[card.key] ?? '—' }}</h4>
                            </div>
                            <div class="stat-icon" :class="card.tone">
                                <i :class="card.icon"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card dashboard-table-card">
            <div class="card-header bg-transparent border-bottom d-flex align-items-center justify-content-between">
                <div>
                    <h5 class="mb-0 card-heading">Project Summary</h5>
                    <small class="text-muted">Deposit, expense and balance by project</small>
                </div>
            </div>
            <div class="card-body p-0">
                <div v-if="loading" class="dashboard-empty">
                    <div class="spinner-border text-primary" role="status"></div>
                </div>
                <div class="table-responsive" v-else>
                    <table class="table table-hover mb-0 dashboard-table">
                        <thead>
                            <tr>
                                <th>Project Name</th>
                                <th class="text-center">Total Share</th>
                                <th class="text-center">Share Holders</th>
                                <th class="text-end">Total Deposit</th>
                                <th class="text-end">Total Expenses</th>
                                <th class="text-end">Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="each in data['projects']" :key="each.id">
                                <td>
                                    <router-link class="project-link" :to="{name: 'shareHolderList', params: {id: each.id}}">
                                        {{ each.project_name }}
                                    </router-link>
                                </td>
                                <td class="text-center">{{ each.total_share }}</td>
                                <td class="text-center">{{ each.total_shareholder }}</td>
                                <td class="text-end">{{ each.total_deposit }}</td>
                                <td class="text-end">{{ each.total_expense }}</td>
                                <td class="text-end">
                                    <router-link class="balance-link" :to="{name: 'balanceSheet', query: {project_id: each.id}}">
                                        {{ each.balance }}
                                    </router-link>
                                </td>
                            </tr>
                            <tr v-if="!data['projects']?.length">
                                <td class="text-center text-muted py-5" colspan="6">No projects found</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "../../Services/ApiService";
import ApiRoutes from "../../Services/ApiRoutes";

export default {
    data() {
        return {
            data: {},
            loading: false,
            summaryCards: [
                { key: 'total_shareholder', label: 'Total Shareholder', icon: 'bx bx-group', tone: 'tone-blue' },
                { key: 'total_project', label: 'Total Project', icon: 'bx bx-buildings', tone: 'tone-indigo' },
                { key: 'total_income', label: 'Total Income', icon: 'bx bx-trending-up', tone: 'tone-green' },
                { key: 'total_expense', label: 'Total Expense', icon: 'bx bx-trending-down', tone: 'tone-orange' },
            ]
        }
    },
    methods: {
        getDashboardData: function () {
            this.loading = true;
            ApiService.POST(ApiRoutes.Dashboard, {}, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.data = res.data;
                }
            });
        }
    },
    created() {
        this.getDashboardData();
    }
}
</script>

<style scoped>
.dashboard-page {
    font-family: Roboto, sans-serif;
    color: #4c5258;
    letter-spacing: 0.2px;
}

.breadcrumb-title {
    font-family: Roboto, sans-serif;
    font-size: 20px;
    font-weight: 500;
    color: #4c5258;
    letter-spacing: 0.3px;
    line-height: 1.2;
    border-right: 1.5px solid #e5e7eb;
}

.dashboard-stat-card {
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.04);
}

.stat-label {
    font-family: Roboto, sans-serif;
    font-size: 13px;
    color: #6c757d;
    margin-bottom: 0.35rem;
    font-weight: 400;
    letter-spacing: 0.2px;
}

.stat-value {
    font-family: Roboto, sans-serif;
    font-size: 22px;
    font-weight: 500;
    color: #2f353c;
    letter-spacing: 0.2px;
    line-height: 1.25;
}

.stat-icon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
}

.tone-blue {
    background: rgba(37, 99, 235, 0.1);
    color: #2563eb;
}

.tone-indigo {
    background: rgba(79, 70, 229, 0.1);
    color: #4f46e5;
}

.tone-green {
    background: rgba(22, 163, 74, 0.1);
    color: #16a34a;
}

.tone-orange {
    background: rgba(234, 88, 12, 0.1);
    color: #ea580c;
}

.dashboard-table-card {
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 4px 12px rgba(15, 23, 42, 0.04);
}

.card-heading {
    font-family: Roboto, sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #2f353c;
    letter-spacing: 0.2px;
}

.card-header small {
    font-family: Roboto, sans-serif;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0.2px;
}

.dashboard-table {
    font-family: Roboto, sans-serif;
}

.dashboard-table thead th {
    background: #f8fafc;
    font-size: 13px;
    font-weight: 500;
    color: #6c757d;
    border-bottom: 1px solid #e5e7eb;
    white-space: nowrap;
    padding: 0.85rem 1rem;
    letter-spacing: 0.2px;
}

.dashboard-table td {
    padding: 0.85rem 1rem;
    vertical-align: middle;
    border-color: #e5e7eb;
    font-size: 14px;
    font-weight: 400;
    color: #4c5258;
    letter-spacing: 0.2px;
}

.project-link {
    font-weight: 500;
    color: #2563eb;
    text-decoration: none;
    letter-spacing: 0.2px;
}

.project-link:hover {
    text-decoration: underline;
}

.balance-link {
    font-weight: 500;
    color: #2f353c;
    text-decoration: none;
    letter-spacing: 0.2px;
}

.balance-link:hover {
    color: #2563eb;
}

.dashboard-empty {
    min-height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
